<template>
  <div style="height: 100%;width: 100%;overflow: hidden;position:relative;display: flex;justify-content: center; align-items: center">
    <div style="width: 300px;">
      <a-input placeholder="请输入秘钥" v-model="secret" @change="handleSecretChange"/>
      <div @click="copyCode" style="border: black 1px solid;padding: 20px;font-size: 30px;text-align: center;cursor:pointer;margin-top: 10px">
        <div>{{code}}</div>
      </div>
      <div style="border: black 1px solid;padding: 5px;font-size: 20px;margin-top: 10px;text-align: center">
        <div>有效期：{{remaining}} 秒</div>
      </div>
    </div>
  </div>
</template>

<script>
import speakeasy from "speakeasy";
import base32 from "thirty-two";

export default {
  name: "index",
  data() {
    return {
      secret: "",
      code: "-",
      remaining: "-",
      interval: null,
    }
  },
  methods: {
    copyCode() {
      this.$copyText(this.code)
      this.$message.success('验证码复制成功');
    },
    handleSecretChange() {
      this.resetInterval()
      this.code = "-"
      this.remaining = "-"
      if (this.secret.length > 0) {
        const cleanedSecret = this.secret.replace(/\s+/g, '').toUpperCase();
        if (/^[A-Z2-7]+=*$/.test(cleanedSecret)) {
          this.refreshCode()
          this.interval = setInterval(this.refreshCode, 1000)
        }
        else {
          this.$message.error('秘钥错误');
        }
      }
    },
    resetInterval() {
      if (this.interval != null) {
        clearInterval(this.interval);
      }
      this.interval = null;
    },
    refreshCode() {
      let result = this.generate2FACode(this.secret);
      this.code = result.code
      this.remaining = String(result.remaining)
    },
    generate2FACode(secret) {
      try {
        // 解码Base32秘钥
        const secretBuffer = base32.decode(secret);

        // 生成TOTP验证码
        const token = speakeasy.totp({
          secret: secretBuffer,
          encoding: 'base32',
          time: Date.now() / 1000
        });

        // 计算剩余有效时间（秒）
        const currentTimeSeconds = Math.floor(Date.now() / 1000);
        const remaining = 30 - (currentTimeSeconds % 30);

        return {
          code: token,
          remaining
        };
      } catch (error) {
        console.error('生成2FA验证码失败:', error.message);
      }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.ant-input {
  border: black 1px solid
}
.ant-input:focus {
  border: black 1px solid
}
</style>
